/**
 * QuoteCard — daily motivational quote card.
 *
 * Used identically on both the Adviser and Assistant dashboards beneath
 * the greeting. White card with a teal-tinted circular icon on the left
 * and the quote + attribution on the right. Renders nothing when no
 * quote is supplied so the surrounding layout stays clean on first
 * paint.
 */

import React from 'react';
import { Quote } from 'lucide-react';

export default function QuoteCard({ quote }) {
  if (!quote) return null;

  return (
    <div style={styles.card}>
      <div style={styles.iconWrap}>
        <Quote size={14} color="#1B9AAA" fill="#1B9AAA" />
      </div>
      <div style={styles.content}>
        <p style={styles.quoteText}>{quote.text}</p>
        <p style={styles.author}>— {quote.author}</p>
      </div>
    </div>
  );
}

// rounded-xl ≈ 12px, p-4 = 1rem, gap-3.5 = 0.875rem, leading-relaxed = 1.625
const styles = {
  card: {
    background: '#FFFFFF',
    border: '1px solid #D0DAE6',
    borderRadius: '12px',
    padding: '1rem',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.875rem',
  },
  iconWrap: {
    width: '32px',
    height: '32px',
    borderRadius: '999px',
    background: 'rgba(27, 154, 170, 0.12)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  quoteText: {
    fontFamily: "'Playfair Display', Georgia, serif",
    fontStyle: 'italic',
    fontSize: '1rem',
    color: 'var(--cp-text)',
    lineHeight: 1.625,
    margin: 0,
  },
  author: {
    fontSize: '0.75rem',
    color: '#6B7A8D',
    marginTop: '0.25rem',
    margin: '0.25rem 0 0 0',
  },
};
